// import React, { useState } from "react";
// // import "./DaySelector.css";

// const DaySelector = ({ selectedDays, setSelectedDays }) => {

//   // Days of the week
//   const daysOfWeek = ["S", "M", "T", "W", "T", "F", "S"];

//   // Toggle day selection
//   const handleDayClick = (day) => {
//     if (selectedDays.includes(day)) {
//       // Remove day from selected days
//       setSelectedDays(selectedDays.filter((d) => d !== day));
//     } else {
//       // Add day to selected days
//       setSelectedDays([...selectedDays, day]);
//     }
//   };

//   return (
//     <div className="day-selector">
//       {daysOfWeek.map((day, index) => (
//         <div
//           key={index}
//           className={`day-circle ${selectedDays.includes(day) ? "selected" : ""}`}
//           onClick={() => handleDayClick(day)}
//         >
//           {day}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default DaySelector;

import React, {useEffect, useState} from "react";

const DaySelector = ({ selectedDays, setSelectedDays, editVal, currentValues}) => {

  // Days of the week with unique identifiers
  const daysOfWeek = [
    // { id: 0, label: "S" }, // Sunday
    // { id: 1, label: "M" }, // Monday
    // { id: 2, label: "T" }, // Tuesday
    // { id: 3, label: "W" }, // Wednesday
    // { id: 4, label: "T" }, // Thursday
    // { id: 5, label: "F" }, // Friday
    // { id: 6, label: "S" }, // Saturday
    { id: 0, label: "S", key: "rscSun" }, // Sunday
    { id: 1, label: "M", key: "rscMon" }, // Monday
    { id: 2, label: "T", key: "rscTue" }, // Tuesday
    { id: 3, label: "W", key: "rscWed" }, // Wednesday
    { id: 4, label: "T", key: "rscThu" }, // Thursday
    { id: 5, label: "F", key: "rscFri" }, // Friday
    { id: 6, label: "S", key: "rscSat" }, // Saturday
  ];

  // useEffect(() => {
  //   if (editMode && currentValues.length > 0) {
  //     setSelectedDays(currentValues);
  //   }
  // }, [editMode, currentValues]);
  useEffect(() => {
    if (editVal) {
      const preSelectedDays = daysOfWeek
          .filter((day) => editVal[day.key]) // Check if day is selected
          .map((day) => day.id); // Extract IDs of selected days
      setSelectedDays(preSelectedDays);
    }
  }, [editVal, setSelectedDays]);
  // Toggle day selection
  const handleDayClick = (id) => {
    if (selectedDays.includes(id)) {
      // Remove day from selected days
      setSelectedDays(selectedDays.filter((dayId) => dayId !== id));
    } else {
      // Add day to selected days
      setSelectedDays([...selectedDays, id]);
    }
  };

  return (
    <div className="day-selector">
      {daysOfWeek.map((day) => (
        <div
          key={day.id}
          className={`day-circle ${selectedDays.includes(day.id) ? "selected" : ""}`}
          onClick={() => handleDayClick(day.id)}
        >
          {day.label}
        </div>
      ))}
    </div>
  );
};

export default DaySelector;

